<script>
import { mapGetters } from 'vuex'
export default
{
    computed:
    {
        ...mapGetters({
            user: 'authUser'
        })
    },

    methods:
    {
        save()
        {
            this.$api('put', '/v1/user', this.user, {
                title: '',
                body: this.$t('GENERAL.SAVING'),
                success: this.$t('GENERAL.SAVED'),
            }).then((user) => {
                this.$store.dispatch('fetchUser')
            })
        },

        savePassword()
        {
            this.$api('put', '/v1/user/password', this.password, {
                title: '',
                body: this.$t('GENERAL.SAVING'),
                success: this.$t('GENERAL.SAVED'),
            }).then((user) => {
                this.$store.dispatch('fetchUser')
            })
        }

    },

    data()
    {
        return {
            password: {
                current_password: null,
                password: null,
                password_confirmation: null,
            }
        }
    },

}
</script>

<template>
<div>
    <div class="panel panel-primary">
        <div class="panel-heading">
            <h4>
                {{ $t('MENU.PROFILE') }}
            </h4>
        </div>
        <div class="panel-body">
            <form @submit.prevent.stop="save">

                <div class="form-group">
                    <label for="name" class="col-md-4 control-label">
                        {{ $t('USER.EMAIL') }}
                    </label>
                    <div class="col-md-6">
                        <input type="text" class="form-control" disabled :value="user.email">
                    </div>
                </div>

                <div class="form-group">
                    <label for="name" class="col-md-4 control-label">
                        {{ $t('USER.NAME') }}
                    </label>
                    <div class="col-md-6">
                        <input type="text" class="form-control" name="name" v-model="user.name" required>
                    </div>
                </div>

                <div class="form-group">
                    <label for="name" class="col-md-4 control-label">
                        {{ $t('USER.LANGUAGE') }}
                    </label>
                    <div class="col-md-6">
                        <select name="locale" v-model="user.locale" class="form-control">
                            <option value="hu">Magyar</option>
                            <option value="en">English</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <div class="col-md-8 col-md-offset-4">
                        <button class="btn btn-success">{{ $t('GENERAL.SAVE') }}</button>
                    </div>
                </div>

            </form>
        </div>
    </div>

    <div class="panel panel-primary">
        <div class="panel-heading">
            <h4>
                {{ $t('USER.PASSWORD') }}
            </h4>
        </div>
        <div class="panel-body">
            <form @submit.prevent.stop="savePassword">

                <div class="form-group">
                    <label for="name" class="col-md-4 control-label">
                        {{ $t('USER.PASSWORD') }}
                    </label>
                    <div class="col-md-6">
                        <input type="password" class="form-control" name="name" v-model="password.current_password" required>
                    </div>
                </div>

                <div class="form-group">
                    <label for="name" class="col-md-4 control-label">
                        {{ $t('USER.NEW_PASSWORD') }}
                    </label>
                    <div class="col-md-6">
                        <input type="password" class="form-control" name="name" v-model="password.password" required>
                    </div>
                </div>

                <div class="form-group">
                    <label for="name" class="col-md-4 control-label">
                        {{ $t('USER.PASSWORD_CONFIRMATION') }}
                    </label>
                    <div class="col-md-6">
                        <input type="password" class="form-control" name="name" v-model="password.password_confirmation" required>
                    </div>
                </div>

                <div class="form-group">
                    <div class="col-md-8 col-md-offset-4">
                        <button class="btn btn-success">{{ $t('GENERAL.SAVE') }}</button>
                    </div>
                </div>

            </form>
        </div>
    </div>
</div>
</template>


// WEBPACK FOOTER //
// src/pages/Profile.vue